import React, { useState } from "react";
import { Download, Share2, PlusSquare } from "lucide-react";
import { useInstall } from "../context/InstallContext";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";
import "./install-prompt.css";

export default function InstallPrompt() {
  const { eligible, isIos, isSafari, canPrompt, install, dismiss, pending, error } = useInstall();
  const { t } = useLanguage();
  const [showSteps, setShowSteps] = useState(false);
  if (!eligible) return null;

  return <section className="install-inline" data-testid="install-prompt" aria-labelledby="install-heading">
    <div className="install-inline-heading">
      <img src="/icon-192.png" alt="" width="36" height="36" data-testid="install-app-icon" />
      <div>
        <h2 id="install-heading" data-testid="install-title">{t.install.title}</h2>
        <p data-testid="install-subtitle">{t.install.subtitle}</p>
      </div>
    </div>
    <div className="install-inline-actions">
      <Button data-testid="install-btn" type="button" className="install-primary" disabled={pending || error}
        aria-expanded={isIos && !canPrompt ? showSteps : undefined}
        aria-controls={isIos && !canPrompt ? "install-ios-steps" : undefined}
        onClick={() => canPrompt ? install() : setShowSteps(v => !v)}>
        <Download size={15} /> {pending ? t.install.waiting : t.install.action}
      </Button>
      <Button data-testid="install-dismiss-btn" type="button" variant="ghost" className="install-later" disabled={pending} onClick={dismiss}>
        {t.install.later}
      </Button>
    </div>
    {showSteps && isIos && <ol id="install-ios-steps" className="install-inline-steps" data-testid="install-ios-steps">
      <li data-testid="install-ios-step-share"><Share2 size={15} aria-hidden="true" /><span>{isSafari ? t.install.iosShare : t.install.iosOpenSafari}</span></li>
      <li data-testid="install-ios-step-add"><PlusSquare size={15} aria-hidden="true" /><span>{t.install.iosAdd}</span></li>
    </ol>}
    {error && <p role="alert" data-testid="install-error" className="install-inline-error">{t.install.error}</p>}
  </section>;
}